import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"
import Home from "./pages/Home"
import About from "./pages/About"
import WhyUs from "./pages/WhyUs"
import Faq from "./pages/Faq"
import Crypto from "./pages/Crypto"
import Forex from "./pages/Forex"
import Legal from "./pages/Legal"
import Policy from "./pages/Policy"
import Terms from "./pages/Terms"
import LoginPage from "./pages/LoginPage"
import Account from "./pages/Account"
import Register from "./pages/Register"
import Forget from "./pages/Forget"
import Reset from "./pages/Reset"
import Swap from "./pages/Swap"
import Dashboard from "./pages/Dashboard"
import Dashboard1 from "./pages/Dashboard1"
import Deposit from "./pages/Deposit"
import Withdraw from "./pages/Withdraw"
import Assets from "./pages/Assets"
import Markets from "./pages/Markets"
import Mining from "./pages/Mining"
import Bots from "./pages/Bots"
import Trade from "./pages/Trade"
import Subscribe from "./pages/Subscribe"
import Copyexpert from "./pages/Copyexpert"
import Signal from "./pages/Signal"
import Stake from "./pages/Stake"
import { UserProvider } from "./utils/UserContext";
import "./App.css"

function App() {
  return (
    <Router>
      <UserProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/whyus" element={<WhyUs />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/crypto" element={<Crypto />} />
          <Route path="/forex" element={<Forex />} />
          <Route path="/legal" element={<Legal />} />
          <Route path="/policy" element={<Policy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/dashboard1" element={<Dashboard1 />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/deposit" element={<Deposit />} />
          <Route path="/withdraw" element={<Withdraw />} />
          <Route path="/account" element={<Account />} />
          <Route path="/swap" element={<Swap />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<Forget />} />
          <Route path="/reset-password" element={<Reset />} />
          <Route path="/assets" element={<Assets />} />
          <Route path="/markets" element={<Markets />} />
          <Route path="/mining" element={<Mining />} />
          <Route path="/bot" element={<Bots />} />
          <Route path="/trade" element={<Trade />} />
          <Route path="/copyexpert" element={<Copyexpert />} />
          <Route path="/subscribe" element={<Subscribe />} />
          <Route path="/signal" element={<Signal />} />
          <Route path="/stake" element={<Stake />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </UserProvider>
    </Router>
  )
}

export default App